import { Component, OnInit,Input } from '@angular/core';
import{correoService, archivosCompartidosService, GlobalsService, LoopBackAuth} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';


@Component({
  selector: 'view-mail',
  template: `
  <div class="card">
      <div class="card-header">
          <h5>{{mail.asunto}}</h5>
          <h6 class="f-right f-12">{{mail.fecha}}</h6>
      </div>
    <div class="card-block pb-0">
      <div class="media mb-0">
          <div class="media-left photo-table">
              <div class="border bg-primary p-2" [style.border-radius]="'50%'">{{mail.apellido | slice:0:1}}{{mail.nombre | slice:0:1}}</div> 
          </div>
          
          <div class="media-body photo-contant">
              <h6 class="user-name txt-primary">{{mail.de.apellido}}  {{mail.de.nombre}}</h6>
              <h6 [style.margin-bottom]="'40px'"> <strong>Para: </strong> <span *ngFor="let item of mail.para" class="f-10">{{item.apellido}} {{item.nombre}}, </span></h6>
              <div class="contenedor-adjuntos">
                  <div class="contenedor">
                    <div class="adjunto cursor" *ngFor="let item of archivos" (click)="descargarArchivo(item)" title="{{item.nombre}}">
                      <div class="adjunto-imagen">
                          <img [src]="item.icono_on" width="25px" class="icono" style="margin:auto">
                      </div>
                      <div style="position: relative;">
                          <div>
                              <div class="f-12 m-0">{{item.nombre | shorten: 23: '...'}}</div>
                              <div class="f-11 mb-0">{{item.tamanio/1000000 | number}} MB</div>
                          </div>
                      </div>
                    </div>
                  </div>
              </div>
              <hr/>
              <div [innerHTML]="mail.mensaje"> </div>
          </div>
      </div>
      
    </div>
</div>
<hr/> 
  `,
  providers:[archivosCompartidosService, correoService,MessageService, GlobalsService, LoopBackAuth]
})
export class ViewMailComponent implements OnInit {
  @Input() mail:any

  public archivos:any[]=[]
  public extenciones:any[]=[]
  constructor(
    private correoService:correoService,
    private global: GlobalsService,
    private LoopBackAuth:LoopBackAuth
  ) { }
  ngOnInit() {
    this.getArchivosAdjuntos(this.mail.glb_correo_mensaje_principal_id)
  }
  private getArchivosAdjuntos(id:number){
    this.correoService.archivosAdjuntos(id).subscribe(
      result=>{
        console.log("archivos -->", result)
        this.archivos = result
      }
    )
  }

  public descargarArchivo(item:any){
    let link = this.global.baseAPIUrl+"/correoMensaje/descargas/"+this.LoopBackAuth.load().token+"/"+item.id
    window.open(link)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/view-mail.component.ts